import React from 'react'
import Contact from './contact/Contact'
import Download_app from '../common/download-app/Download_app'

function Contact_us() {
    return (
        <>
            <Contact />
            <Download_app />
        </>
    )
}

export default Contact_us